'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 4.828a2 2 0 0 1 .586-1.414l.828-.828A2 2 0 0 1 9.828 2h4.344a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 1 17 4.828v6.566a2 2 0 0 0 .336 1.11l1.406 2.11c.168.251.258.548.258.85v0c0 .849-.687 1.536-1.535 1.536H6.535A1.535 1.535 0 0 1 5 15.465v0c0-.303.09-.6.258-.852l1.406-2.11A2 2 0 0 0 7 11.395z" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={2} d="M12 17v5" /></svg>;
const IconPin = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconPin;